var types = exports.types = {
  'GoodEx.UniversalModels.Views.ApplicationTextQuestionView, GoodEx.UniversalModels': 'Text',
  'GoodEx.UniversalModels.Views.ApplicationDropdownListQuestionView, GoodEx.UniversalModels': 'Dropdown',
  'GoodEx.UniversalModels.Views.ApplicationMultipleChoiceQuestionView, GoodEx.UniversalModels': 'Multiple Choice',
  'GoodEx.UniversalModels.Views.ApplicationBooleanQuestionView, GoodEx.UniversalModels': 'Boolean',
  'GoodEx.UniversalModels.Views.ApplicationNumberQuestionView, GoodEx.UniversalModels': 'Number',
  'GoodEx.UniversalModels.Views.ApplicationSingleDateQuestionView, GoodEx.UniversalModels': 'Date',
  'GoodEx.UniversalModels.Views.ApplicationCurrencyQuestionView, GoodEx.UniversalModels': 'Currency',
  'GoodEx.UniversalModels.Views.ApplicationGeoLocationQuestionView, GoodEx.UniversalModels': 'Geolocation',
  'GoodEx.UniversalModels.Views.ApplicationCategoryQuestionView, GoodEx.UniversalModels': 'Category',
  'GoodEx.UniversalModels.Views.ApplicationDocumentUploadQuestionView, GoodEx.UniversalModels' : 'Document Upload',
  'GoodEx.UniversalModels.Views.ApplicationTableQuestionView, GoodEx.UniversalModels': 'Table',
  'GoodEx.UniversalModels.Views.ApplicationTotalsTableQuestionView, GoodEx.UniversalModels': 'TotalsTable',
  'AdminNumberRangeQuestionView' : 'Number Range'
}


exports.matches = function matches(str){
  for (var key in types) {
    var type = types[key];
    if (type == str) return key;
  }
}
